<template>
	<div class="main">
		<header class="page-title">
			<h2>Meta&Seo <span class="page-description"><i class="fas fa-info-circle icon-left"></i> The settings on this tab apply to the whole article</span>
			</h2>
			<div class="ml-auto">
				<button @click.prevent="saveMetaSeo" class="btn btn-md btn-success">
					<i class="fas fa-save"></i> Save Changes
				</button>
			</div>
		</header>
		<meta-tags-card :current-instance-id="data.id" :data-card-meta-seo-box="data.articleMetaSeoMetaSeo"></meta-tags-card>
		<article-meta-seo-recommended-articles :meta-seo-recommended-articles="data.articleMetaSeoRecommendedArticles"></article-meta-seo-recommended-articles>
		<article-meta-seo-redirects :meta-seo-redirects="data.articleMetaSeoRedirects"></article-meta-seo-redirects>
	</div>
</template>

<script>
	import {eventBus} from "../../app";

	export default {
		props: {
			data: {
				required: true
			}
		},
		methods: {
			saveMetaSeo: function() {
				let vm = this;
				let originData = _.cloneDeep(vm.data);
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.data.id + '/saveMetaSeo', vm.data)
						.then(function (response) {
							if (response.data) {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Article Meta&Seo saved.', 'Success');
							}
						})
						.catch(function (e) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error('Article Meta&Seo save failed.', 'Error');
							vm.data = originData;
						});
			}
		}
	}
</script>

<style scoped>

</style>
